import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  geoZoneNameWrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: ".5rem"
  },
  geoZoneName: {
    fontWeight: "bold"
  }
}))

export default useStyles;
